'use client';

import React from 'react';
import { useBookingConfiguration } from '../../hooks/useBookingConfiguration';
import { StoryblokComponent } from 'gatsby-source-storyblok';

const HotelRequest = ({ hotel, showRequestModal, setShowRequestModal }) => {
  const { content } = useBookingConfiguration();

  const form = JSON.parse(content).hotel_request_form;

  return (
    <div
      className={`${
        showRequestModal ? 'flex' : 'hidden'
      } fixed inset-0 bg-black bg-opacity-50 transition-opacity z-60`}
      onClick={() => setShowRequestModal(!showRequestModal)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          setShowRequestModal(!showRequestModal);
        }
      }}
    >
      <div className="w-full max-w-screen-lg mx-auto lg:relative">
        <div
          className={`${
            showRequestModal ? '' : 'inset-y-full'
          } flex flex-wrap items-center w-full fixed lg:absolute bg-yellow-15 rounded-t-2xl z-50 bottom-0 lg:bottom-8 lg:rounded-2xl p-4 max-w-screen-sm lg:max-w-screen-lg left-1/2 lg:left-auto -translate-x-1/2 lg:transform-none transition-[inset] lg:max-h-[calc(100vh-1rem)]`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="w-full mt-4 pb-4 overflow-y-auto max-h-[80vh] lg:max-h-[80vh]">
            {form &&
              form.map((nestedBlok) => (
                <StoryblokComponent
                  blok={nestedBlok}
                  key={nestedBlok._uid}
                  defaultValues={{ Hotel: hotel?.name }}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelRequest;
